import { render, staticRenderFns } from "./VerifyEmailStep.vue?vue&type=template&id=1d1fdc14&scoped=true&"
import script from "./VerifyEmailStep.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailStep.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailStep.vue?vue&type=style&index=0&id=1d1fdc14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1fdc14",
  null
  
)

export default component.exports